export default __webpack_public_path__ + "static/media/submenu-robot-M8.60bfb34d.png";